module.exports = __webpack_public_path__ + "img/checked.bd9bad71.svg";